import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import butter from './butter-client'

import './BlogStyle.css';

import { Container, Row, Col, Image } from 'react-bootstrap';


class App extends Component {
  state = {
    meta: {},
    data: []
  }
  async componentDidMount() {
    const { match } = this.props
    let page = match.params.page || 1

    const resp = await butter.post.list({ page: page, page_size: 10 })
    this.setState(resp.data)
  }
  render() {
    const { next_page, previous_page } = this.state.meta


    return (
      <Container>

        {this.state.data.map((post, key) => {
          return (
            <div key={key} className="d-inline-block col-md-6 align-top h-100 p-2">
              <Link to={`/blog/posts/${post.slug}`} className="card-link card h-100 p-4">
                <Image fluid className="blog-post-img-link" src={post.featured_image} />
                <h4 className="pt-4">{post.title}</h4>
                <p>{post.summary}</p>
              </Link>
            </div>
          )
        })}

        <br />

        <div className="p-5 text-center">
          {previous_page && (
            <Link to={`/blog/${previous_page}`}>
              <a className="bps-link-button">Prev</a>
            </Link>
          )}

          {next_page && (
            <Link to={`/blog/${next_page}`}>
              <a className="bps-link-button">Next</a>
            </Link>
          )}
        </div>
      </Container>
    )
  }
}

export default App